import DetailSubscription from "@dropDesk/presentation/components/detail_subscription";
import React from "react";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {ContentTable} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/invoices_history/styled";
import {observer} from "mobx-react";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import TablePaymentsHistory from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table";

const PaymentsHistory = observer((
    {
        tablePayments,
        loading,
        getDataFromPagePayments,
        onClickDownloadInvoice,
        currentSubscription,
        onClickExternallyPay,
        onClickRefundPay
    }: {
        tablePayments: ListPaginationEntity<PaymentEntity>,
        loading: boolean
        getDataFromPagePayments: (page: number) => void,
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        onClickExternallyPay: (payment: PaymentEntity) => void
        onClickRefundPay: (payment: PaymentEntity) => void
        currentSubscription: PaymentSubscriptionEntity

    }
) => {

    return (
        <DetailSubscription
            title={'Histórico de faturas'}
            description={'Consulta todas as suas faturas emitidas'}
            content={
                <ContentTable>
                    <TablePaymentsHistory
                        tablePayments={tablePayments}
                        loading={loading}
                        getDataFromPagePayments={getDataFromPagePayments}
                        onClickDownloadInvoice={onClickDownloadInvoice}
                        currentSubscription={currentSubscription}
                        onClickExternallyPay={onClickExternallyPay}
                        onClickRefundPay={onClickRefundPay}
                    />
                </ContentTable>
            }
        />
    );
});
export default PaymentsHistory;
